import React, { useEffect } from "react";
import Join from "../../Join";
import Footer from "../../Footer";
import Header from "./Header";
import Patners from "../../../Layout/Part/Patners";
import Main from "./Main";
import CustomInputs from "./CustomInputs";

const Supports2 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {};
  }, []);
  return (
    <>
      <Header />
      <Main />
      <Patners />
      <CustomInputs />
      <Join />
      <Footer />
    </>
  );
};

export default Supports2;
